import React from 'react';
import { Container, Grid, Link } from '@material-ui/core';
import config from '../../../config';
export default function Footer(){
  return(
    <footer className="footer">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item md={2} xs={6}>
            <h4>Media Center</h4>
            <ul className="list-unstyled">
              {[
                {title:'Blog', path:'https://www.acumen.aero/blogs'},
                {title:'Events', path:'https://www.acumen.aero/event'},
                {title:'Webinar', path:'https://www.acumen.aero/webinar'},
                {title:'Resources', path:'https://www.acumen.aero/market-insights'},
                {title:'Press Releases', path:'https://www.acumen.aero/press-release'},
                {/* {title:'Video & Podcast', path:'https://www.acumen.aero/resources/webinars/'} */}
              ].map(({title, path}, index) =>
                <li key={index}>
                  <Link href={path} target="_blank"  className="links-footer" >{title}</Link>
                </li>
              )}
            </ul>
          </Grid>
          <Grid item md={2} xs={6}>
            <h4>About Us</h4>
            <ul className="list-unstyled">
              {[
                {title:'Our Team', path:'https://www.acumen.aero/leadership'},
                {title:'Clients', path:'https://www.acumen.aero/clients'},
                {title:'Careers', path:'https://www.acumen.aero/careers'},
              ].map(({title, path}, index) =>
                <li key={index}>
                  <Link href={path} target="_blank" className="links-footer">{title}</Link>
                </li>
              )}
            </ul>
          </Grid>
          <Grid item md={2} xs={6}>
            <h4>Features</h4>
            <ul className="list-unstyled">
              {[
              {title:'Lease Management', path:config.domain.subDomian+'solutions?target=module-features&tabIndex=0'},
              {title:'Records Dataroom', path:config.domain.subDomian+'solutions?target=module-features&tabIndex=3'},
              {title:'Projects Management', path:config.domain.subDomian+'solutions?target=module-features&tabIndex=2'},
              {title:'Maintenance Claim Management', path:config.domain.subDomian+'solutions?target=module-features&tabIndex=1'},
              {title:'commVerge', path:config.domain.subDomian+'solutions?target=other-features&tabIndex=1'},
              {title:'fin-S', path:config.domain.subDomian+'solutions?target=other-features&tabIndex=0'},
              ].map(({title, path}, index) =>
                <li key={index}>
                  <Link href={path} target="_blank" className="links-footer">{title}</Link>
                </li>
              )}
            </ul>
          </Grid>
          <Grid item md={2} xs={6}>
            <h4>Others</h4>
            <ul className="list-unstyled">
              {[
                {title:'Terms & Conditions', path: config.domain.subDomian+'termscondition'},
                {title:'Data Policy', path:config.domain.subDomian+'data-policy'},
                {title:'Privacy Policy', path:"https://www.acumen.aero/policy"},
                {title:'Security', path:"https://www.acumen.aero/policy?security=true"},
                ].map(({title, path}, index) =>
                <li key={index}>
                  <Link href={path} target="_blank" className="links-footer">{title}</Link>
                </li>
              )}
            </ul>
          </Grid>
          <Grid item md={4} xs={12}>
            <h4>Contact with Us</h4>
            <ul className="list-inline">
              {[
                {path:'https://www.facebook.com/SPARTAaero-354530545100281/', img:'https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/phase-2/facebook.svg'},
                {path: 'https://www.instagram.com/sparta.aero/', img:'https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/phase-2/instagram.svg'},
                {path: 'https://www.linkedin.com/company/sparta-aero/', img:'https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/phase-2/icon_LinkedIn.svg'},
                {path: 'https://twitter.com/aero_sparta', img:'https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/phase-2/twitter.svg'},
              ].map(({path, img}, index) =>
                <li className="list-inline-item" key={index}>
                  <Link href={path} target="_blank">
                    <img src={img} alt="" />
                  </Link>
                </li>
              )}
            </ul>
            <h4>Contact Us</h4>
            <Link href="mailto:support@sparta.aero" target="_blank">support@sparta.aero</Link>
          </Grid>
        </Grid>
      </Container>
      <div className="text-center footer-copyright">
        <Link to="">
          <img src="https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/phase-2/acumen.png" alt="" />
        </Link>
        <p>© 2022 Acumen Aviation Europe Limited. All rights reserved. <a href="https://www.acumen.aero/" target="_blank">www.acumen.aero</a></p>
      </div>
    </footer>
  )
}
